<template>
  <div class="fold">
    <div class="logo"><img src="~assets/common/logo-default.png"/></div>
    <div class="wrapper">
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item :title='$t("join.nav.title")' name="1">
          <ul>
            <!--<li><router-link to="/join">{{$t("join.nav.item1")}}</router-link></li>-->
            <li><router-link to="/join">{{$t("join.nav.item2")}}</router-link></li>
            <li><router-link to="/join/position">{{$t("join.nav.item3")}}</router-link></li>
            <li><router-link to="/join/statement">{{$t("join.nav.item4")}}</router-link></li>
            <li><router-link to="/join/legal">{{$t("join.nav.item5")}}</router-link></li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Fold',
  data () {
    return {
      activeName: '1'
    }
  },
  mounted () {
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .fold
    width 18%
    height 500px
    background #FFF
    ul
      background #f9fafa
      text-indent 30px
    li
      cursor pointer
      line-height 28px
    li:hover
      background #eeeeee
    a
      display block
    .wrapper
      margin-top 39px
</style>



// WEBPACK FOOTER //
// src/pages/join/components/Fold.vue